import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import { Button, Field, Spinner } from "../components/ui/kit";
import api, { apiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/api/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Obnovení hesla"
      subtitle="Pošleme ti odkaz pro nastavení nového hesla."
      footer={
        <Link to="/login" className="text-accent font-600 hover:text-accent-hover">
          Zpět na přihlášení
        </Link>
      }
    >
      {done ? (
        <div className="card p-5 text-[13px] text-sec" data-testid="forgot-done">
          Pokud e-mail existuje, poslali jsme na něj odkaz pro obnovení hesla. Zkontroluj schránku.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="E-mail">
            <input type="email" className="field" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="jmeno@firma.cz" data-testid="forgot-email" required />
          </Field>
          {error && <div className="text-[12.5px] text-danger">{error}</div>}
          <Button className="w-full justify-center" disabled={loading} data-testid="forgot-submit">
            {loading ? <Spinner /> : "Poslat odkaz"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
